import axios from 'axios';

// Points to your live server — change this to your domain when you get one
const API_BASE = process.env.REACT_APP_API_URL || 'https://app.qlicxo.com/api/v1';

const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
});

// Automatically attach token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('leadex_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  // View As: send impersonated user ID so server applies their data scope
  const viewAsId = localStorage.getItem('leadex_view_as_id');
  if (viewAsId) {
    config.headers['X-View-As'] = viewAsId;
    const viewAsType = localStorage.getItem('leadex_view_as_type');
    if (viewAsType) {
      config.headers['X-View-As-Type'] = viewAsType;
    }
  }
  return config;
});

// If token expires, redirect to login
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('leadex_token');
      localStorage.removeItem('leadex_user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;